export default "__VITE_ASSET__58d6545f__"